import { forwardRef } from 'react';
import { StyledDel } from './styled';

const Del = forwardRef((props, ref) => <StyledDel ref={ref} {...props} />);

export default Del;
